module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"after":"Após","fine-of":"multa de","daily-interest-of":"acréscimos diários de"},"en-US":{"after":"Após","fine-of":"fine of","daily-interest-of":"daily interest of"}}')
  delete Component.options._Ctor
}
